<template>
	<div id="dialog-warpper">
		<el-dialog
			:title="assetForm.title"
			:visible.sync="isShow"
			:show-close="false"
			:close-on-click-modal="false"
			class="default-dialog category-dialog">
			<el-form ref="form" :model="form" :rules="rulesForm" label-width="120px">
				<el-form-item label="类别编码：" prop="genresCode">
					<el-input
						size="mini"
						placeholder="请输入编码"
						v-model="form.genresCode">
					</el-input>
				</el-form-item>
				<el-form-item label="类别名称：" prop="genresName">
					<el-input
						size="mini"
						placeholder="请输入名称"
						v-model="form.genresName">
					</el-input>
				</el-form-item>
				<el-form-item label="折旧方法：" prop="depreciationMethod">
					<el-select
						size="mini"
						placeholder="请选择"
						v-model="form.depreciationMethod"
						@change="depreciationMethodChange">
					    <el-option
					    	v-for="item in options"
					    	:key="item.value"
					    	:label="item.label"
					    	:value="item.value">
					    </el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item label="预计使用年限：" prop="estimateAge">
					<el-input
						size="mini"
						placeholder="请输入年"
						class="asset-age-limit"
						v-model="form.estimateAge"
						@keyup.native="provingNumber($event, 'estimateAge')">
					</el-input>
					<span>折为</span>
					<el-input
						size="mini"
						v-model="estimateMonth"
						class="asset-stage"
						disabled>
					</el-input>
					<span>期</span>
				</el-form-item>
				<el-form-item label="预计净残值率：" prop="residualRatio">
					<el-input
						size="mini"
						placeholder="请输入净残值率"
						class="asste-residual-ratio"
						v-model="form.residualRatio"
						>
							
						</el-input>
					<span>%</span>
				</el-form-item>
				<el-form-item label="固定资产科目：" prop="assetsItemId">
					<el-select v-model="form.assetsItemId" filterable placeholder="请选择" size='mini'>
						<el-option
						  v-for="item in subjectData"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"

						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="累计折旧科目：" prop="depreciationItemId">
					<el-select v-model="form.depreciationItemId" filterable placeholder="请选择" size='mini'>
						<el-option
						  v-for="item in subjectData"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"

						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注：">
					<el-input
						type="textarea"
						:rows="5"
						placeholder="请输入备注"
						v-model="form.remarks">
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
		    	<el-button size="small" class="mg-button-cancel" @click="isShow = false">取 消</el-button>
			    <el-button size="small" class='minButton' @click="confirm" :disabled="isDisabled">确 定</el-button>
		  	</span>
		</el-dialog>
	</div>
</template>

<script>

export default {
	components: {
		
	},
	props: {
		assetForm: {
			type: Object,
			default () {
				return {
					data: {
						cid: '',
						id: '',
						genresCode: '',
						genresName: '',
						depreciationMethod: '1',
						estimateAge: '',
						estimateMonth: '',
						residualRatio: '',
						assetsItemId: '',
						subjectAssetsItemCode: '',
						subjectAssetsItemName: '',
						depreciationItemId: '',
						subjectDepreciationItemCode: '',
						subjectDepreciationItemName: '',
						remarks: ''
					},
					title: '新增资产类别',
					status: 'add'
				}
			}
		},
		showVisible: Boolean
	},
	data () {
		const validateResourceAssets = (rule, value, callback) => {
			let reg  = 　/^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/
			if (!reg.test(value)) {
				return callback(new Error('只能输入大于0的数字'))
			}
			callback();
		}
		return {
			form: {
				id: '',
				genresCode: '',
				genresName: '',
				depreciationMethod: '1',
				estimateAge: '',
				estimateMonth: '',
				residualRatio: '',
				assetsItemId: '',
				depreciationItemId: '',
				remarks: ''
			},
			options: [{
				label: '平均年限法',
				value: '1'
			},
			{
				label: '不提折旧',
				value: '5'
			}],
			rulesForm: {
				genresCode: [{
					required: true, message: '请输入类别编码'
				}],
				genresName: [{
					required: true, message: '请输入类别名称'
				}],
				depreciationMethod: [{
					required: true, message: '请选择折旧方法'
				}],
				estimateAge: [{
					required: true, message: '请输入预计使用年限'
				}],
				residualRatio: [{
					required: true, validator: validateResourceAssets
				}],
				assetsItemId: [{
					required: true, message: '请选择固定资产科目'
				}],
				depreciationItemId: [{
					required: true, message: '请选择累计折旧科目'
				}],
			},
			assetsItemId: '',
			depreciationItemId: '',
			isDisabled: false
		}
	},
	computed: {
		// 显示弹窗
		isShow: {
			get () {
				return this.showVisible;
			},
			set (val) {
				this.$emit('update:showVisible', val);
			}
		},
		// 期数
		estimateMonth () {
			this.form.estimateMonth = this.form.estimateAge !== '' && !isNaN(this.form.estimateAge) ? (this.form.estimateAge * 1 * 12).toString() : '';
			return this.form.estimateMonth;
		},
		subjectData() {
			return this.$store.state.getSubjectId.SubjectList
		}
	},
	methods: {
		// 查询所有科目
		getSubject () {
			if (!this.subjectData) {
				this.$store.dispatch('getSubject')
			}
		},
		// 只能输入正整数
		provingNumber (e, type) {
			let val = e.target.value;
			val = val.replace(/[^\d]/g,'');
			this.$set(this.form, type, val);
		},
		// 折旧方法变更
		depreciationMethodChange (val) {
			if (val == 5) {
				this.$set(this.rulesForm, 'assetsItemId', { required: false })
				this.$set(this.rulesForm, 'depreciationItemId', { required: false })
				this.$refs.form.clearValidate(['assetsItemId','depreciationItemId']);
			} else {
				this.$set(this.rulesForm, 'assetsItemId', { required: true, message: '请选择固定资产科目' });
				this.$set(this.rulesForm, 'depreciationItemId', { required: true, message: '请选择累计折旧科目' });
			}
		},
		// 确定保存
		async confirm (formName) {
			try {
				let valid = await this.$refs.form.validate();

				if (valid) {
					this.form.residualRatio = parseFloat(this.form.residualRatio);
					this.isDisabled = true;
					try {
						this.$http.post('assets/save',this.form).then(res=>{
							if(res.data.code == '1') {
								this.$message({
									type: 'success',
									message: res.data.msg,
									showClose: true
								})
								this.$emit('onRefresh' , true)
							}
							this.isShow = false;
						})

					} finally {
						this.isDisabled = false;
					}
				}
			} catch (e) {

			}

		},
	},
	created () {
		this.getSubject();
	},
	watch: {
		showVisible (val) {
			if (val) {

				if (this.assetForm.status == 'add') {
					this.$nextTick(() => {
						this.$refs.form.resetFields();
						this.form = Object.assign({}, this.form, this.$options.data().form);
					})
				} else {
					this.$nextTick(() => {
						this.$refs.form.resetFields();
						for (const i in this.form) {
							for (const k in this.assetForm.data) {
								if ( i == k ) {
									this.$set(this.form, i, this.assetForm.data[i]);
								}
							}
						}
					})
				}
			} else {
				setTimeout(() => {
					this.$refs.form.resetFields();
				}, 500)
			}
		},
	}
}
</script>
<style lang='less'>
	#dialog-warpper {
		.category-dialog {
			.el-select {
				width: 100%;
			}
			.asset-age-limit, .asset-stage {
				width: 100px;
			}
			.asste-residual-ratio {
				width: 245px;
			}
			.el-form-item__content > span {
				margin: 0 4px;
			}
			.subjectSelect {
				width: 232px;
			}
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/dialog/category.vue